import React, { useState } from 'react';

import BasicDropdown from '../../../common/BasicDropdown/BasicDropdown';
import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import Label from '../../../common/Labels/Label';
import WorkspaceSelectionDropdown from '../../../common/WorkspaceSelectionDropdown/WorkspaceSelectionDropdown';

export const PIPELINE_STATUS = {
  Inactive: 'inactive',
  Active: 'active',
  All: 'all',
}

const STATUS_OPTIONS = [
  {
    id: PIPELINE_STATUS.All,
    label: 'All Statuses',
  },
  {
    id: PIPELINE_STATUS.Active,
    label: 'Active',
  },
  {
    id: PIPELINE_STATUS.Inactive,
    label: 'Inactive',
  },
]

export const PipelineTableFilterModal = ({
  workspaces = [],
  filter = { workspaces: [], status: PIPELINE_STATUS.All },
  showDialog = false,
  onDialogToggle = () => {},
  onFilterConfirm = () => {},
  onClear = () => {},
  hideStatusDropdown = false,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(filter.status);
  const [selectedWorkspaces, setSelectedWorkspaces] = useState(filter.workspaces);

  const handleConfirmation = () => {
    onFilterConfirm({
      workspaces: selectedWorkspaces,
      status: selectedStatus,
    });
  }

  return (
    <ConfirmationDialog
      title="Filter"
      confirmButtonText="Apply"
      cancelButtonText="Clear All"
      modalAnimationKey="pipeline-admin-table-filter"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onConfirm={handleConfirmation}
      onCancel={onClear}
    >
      <div className="flex flex-col w-small-modal mx-2 my-3">
        {
          !hideStatusDropdown && (
            <div className="flex flex-col m-1">
              <Label className="my-1" bold>Status</Label>
              <BasicDropdown
                values={STATUS_OPTIONS}
                selectedValue={selectedStatus}
                onValueSelected={setSelectedStatus}
                hideLabelInSmallViewports={false}
                dropdownLabel=""
              />
            </div>
          )
        }
        <div className="flex flex-col m-1">
          <Label className="my-1" bold>Workspace</Label>
          <WorkspaceSelectionDropdown
            workspaces={workspaces}
            selectedWorkspaces={selectedWorkspaces}
            setSelectedWorkspaces={setSelectedWorkspaces}
          />
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default PipelineTableFilterModal;
